(function (app) {

    app.provider("iComplyApi",
        [
            function () {
                this.$get = [
                    "portalApiGateway", function (portalApiGateway) {
                        var service = {};

                        service.getToken = function () {
                            return portalApiGateway.get("/iComply/Token");
                        }

                        service.getFastTrackToken = function () {
                            return portalApiGateway.get("/iComply/Token/FastTrack");
                        }

                        return service;
                    }
                ];
            }
        ]);
})(window.app);